import { PATHS } from '@/routes/paths'

export const CONNECTS_TABS = [
  { label: 'Contacts', path: PATHS.connectsContacts },
  { label: 'To-Do List', path: PATHS.connectsTodo },
  { label: 'Email', path: PATHS.connectsEmail },
  { label: 'Pipeline', path: PATHS.connectsPipeline },
  { label: 'Activity', path: PATHS.connectsActivity },
] as const

export type ContactColumnKey =
  | 'name'
  | 'email'
  | 'phone'
  | 'city'
  | 'state'
  | 'country'
  | 'status'

export const CONTACT_COLUMNS: {
  key: ContactColumnKey
  label: string
  sortable: boolean
}[] = [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'email', label: 'Email', sortable: true },
  { key: 'phone', label: 'Phone', sortable: false },
  { key: 'city', label: 'City', sortable: true },
  { key: 'state', label: 'State', sortable: true },
  { key: 'country', label: 'Country', sortable: true },
  { key: 'status', label: 'Status', sortable: true },
]

export const ATTRIBUTE_FILTERS = [
  'Name',
  'Email',
  'First Seen',
  'Signed Up',
  'City',
  'Phone',
  'Last Seen',
  'Last Contacted',
  'Last Heard From',
  'Country',
] as const
